<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router'
import { useActiveOrganization } from 'auth-package'
const activeOrganization = useActiveOrganization()

import { ref, watch } from 'vue'

const route = useRoute()
const router = useRouter()

const menu = ref<string>('')
function changeRoute(name: string) {
    menu.value = name

    router.push({ name })
}

watch(
    () => route.name,
    (routeName) => {
        if (typeof routeName === 'string') {
            menu.value = routeName
        }
    },
    { immediate: true }
)
</script>

<template>
    <el-radio-group v-model="menu" @change="changeRoute" size="small">
        <el-radio-button :label="$t('adminSubMenu.organization')" value="organizationSettings" />
        <el-radio-button
            v-can="'resource|organization-' + activeOrganization.uuid + '~OrganizationMs#read'"
            :label="$t('adminSubMenu.members')"
            value="organizationSettingsMembers"
        />
    </el-radio-group>
</template>
